export const checkEnvironment = process.env.REACT_APP_RUNNING_CONTEXT;
export const checkMockup = process.env.REACT_APP_IS_MOCKUP;

export const MAX_USER_ACCOUNTS = 128;

export const defaultUserAccountItem = {
  username: "",
  password: "",
  description: "",
};

export const defaultUserAccountObj = {
  name: "",
  userAccounts: [],
};
